<template>
  <el-image
    v-bind="$attrs"
    :src="formatSrc"
    :fit="fit"
    class="img"
    @click="click"
  >
    <div slot="error" class="image-slot">
      <i class="el-icon-picture-outline"></i>
    </div>
  </el-image>
</template>

<script>
export default {
  props: {
    src: {
      type: [String, Object],
      default: "",
    },
    fit: {
      type: String,
      default: "cover",
    },
  },
  data() {
    return {};
  },
  computed: {
    formatSrc() {
      let src = this.src;
      // if (src && src.indexOf("assets/img") < 0 && src.indexOf("http") < 0) {
      //   src = BASE_FILE_URL + src;
      // }
      return src;
    },
  },
  methods: {
    click() {
      this.$emit("click");
    },
  },
};
</script>

<style lang="less">
.img {
  display: block;
  width: 100%;
  height: 100%;
}
.image-slot {
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  position: relative;
  .el-icon-picture-outline {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
  }
}
</style>
